import { render, staticRenderFns } from "./camera_detail.vue?vue&type=template&id=175b22f5&scoped=true&"
import script from "./camera_detail.vue?vue&type=script&lang=js&"
export * from "./camera_detail.vue?vue&type=script&lang=js&"
import style0 from "./camera_detail.vue?vue&type=style&index=0&id=175b22f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175b22f5",
  null
  
)

export default component.exports